<div *ngIf="archivedItems?.length > 0 || structCapArchivedItems?.length > 0" class="mt-2 px-4">
  <div class="collapsible-section d-flex bold" (click)="isOpen = !isOpen">
    <div>{{ "CRM.ARCHIVED_SONAR_RECORDS" | translate }} ({{archivedItems.length}}):</div>
    <i class="fa open-chevron mx-2" [ngClass]="isOpen ? 'fa-angle-down' : 'fa-angle-right'"></i>
  </div>
  <div *ngIf="isOpen">
    <table class="w-100 table table-striped">
      <thead>
        <tr class="bold table-header">
          <td></td>
          <td>{{ "CRM.CREATED_DATE" | translate }}</td>
          <td>{{ "CRM.STATUS" | translate }}</td>
          <td>{{ "CRM.ETAKI" | translate | uppercase }}</td>
          <td>{{ "CRM.DILIGENCE_LEAD" | translate }}</td>
          <td>{{ "CRM.DOMAIN" | translate }}</td>
          <td>{{ "CRM.NOTE" | translate }} #</td>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let item of archivedItems">
          <td><a [routerLink]="SONAR_ITEM_ROUTE + item.id" target="_blank">{{item.name}}</a></td>
          <td>{{item.created.substring(0,10)}}</td>
          <td>{{statusLabels[item.status]}}</td>
          <td>{{item.companies[0]?.etaki && crmStatusService.hasEtakiStatus(item) ? item.companies[0]?.etaki : '-'}}</td>
          <td>{{item.leader?.user?.fullName ? item.leader.user.fullName : '-'}}</td>
          <td>{{item.domains[0]?.name}}</td>
          <td>{{item.notes ? item.notes.length : 0}}</td>
        </tr>
      </tbody>
    </table>

    <table class="w-100 table table-striped">
      <thead>
        <tr class="bold table-header">
          <td></td>
          <td>{{ "CRM.CREATED_DATE" | translate }}</td>
          <td>{{ "CRM.STATUS" | translate }}</td>
          <td>{{ "CRM.CRM_TABLE.DEAL_SIZE" | translate }}</td>
          <td>{{ "CRM.STRUCT_CAP.DEAL_LEAD" | translate }}</td>
          <td>{{ "CRM.STRUCT_CAP.TEAM" | translate }}</td>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let item of structCapArchivedItems">
          <td><a [routerLink]="STRUCT_CAP_ITEM_ROUTE + item.id" target="_blank">{{item.name}}</a></td>
          <td>{{ item.created.substring(0,10) }}</td>
          <td>{{ structCapStatusLabels[item.status] }}</td>
          <td>{{ item.totalDealSize }} | {{ item.raDealSize }}</td>
          <td>{{ item.leader?.user.fullName }}</td>
          <td>{{ item.participants | rmsMap:getParticipantName | rmsJoin }}</td>
        </tr>
      </tbody>
    </table>
  </div>
</div>

